import type { CustomFieldDefinition } from '@/modules/inventory/types';
import { OPTION_FIELD_TYPES } from '@/modules/inventory/types';

export function parseOptionsText(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
}

export function formatOptionsForInput(options: string[]): string {
  return options.join('\n');
}

export function emptyValueForFieldType(
  type: CustomFieldDefinition['type'],
): unknown {
  if (type === 'boolean') return false;
  if (type === 'number') return '';
  if (type === 'multiselect') return [] as string[];
  return '';
}

export function validateCustomFieldValues(
  definitions: CustomFieldDefinition[],
  values: Record<string, unknown>,
): string | null {
  for (const field of definitions) {
    if (!field.active) continue;
    const raw = values[field.key];
    const empty =
      raw === undefined ||
      raw === null ||
      raw === '' ||
      (Array.isArray(raw) && raw.length === 0);

    if (field.required && empty) {
      return `El campo "${field.label}" es obligatorio.`;
    }

    if (
      OPTION_FIELD_TYPES.includes(field.type) &&
      typeof raw === 'string' &&
      raw &&
      !field.options.includes(raw)
    ) {
      return `Valor inválido en "${field.label}".`;
    }

    if (field.type === 'multiselect' && Array.isArray(raw)) {
      const invalid = raw.some((v) => !field.options.includes(String(v)));
      if (invalid) return `Opción inválida en "${field.label}".`;
    }
  }
  return null;
}
